const name = 'ImageReveal';
const properties = {
    hideOnStart: false,
    getMediaDimensions(width, _height, screenHeight) {
        return { width, height: screenHeight };
    },
    groups: ['animation', 'background'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        componentHeight: {
            type: 'number',
            min: 0,
        },
        viewPortHeight: {
            type: 'number',
            min: 0,
        },
        speedFactor: {
            type: 'number',
            default: -1,
        },
    },
};
function animate(kit, elements, duration, delay, { componentHeight, componentTop, siteHeight, viewPortHeight, speedFactor = properties.schema.speedFactor.default, ...params } = {}) {
    const sequence = kit.sequence(params);
    const to = componentHeight;
    const from = -viewPortHeight;
    sequence.add(kit.animate('BasePosition', elements, duration, delay, {
        ease: 'none',
        from: { y: from },
        to: { y: to },
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=imageReveal.js.map